<template>
  <div class="mt-4 flex flex-col gap-4">

    <h2 class="py-6 font-bold text-lg">{{ userName }}</h2>

    <module v-for="module in modules" :module="module" @count-users-changed="countUsersChanged($event, module)"/>
  </div>
</template>

<script>
import Translate from "@shared/mixin/Translate";
import Requests from "@shared/mixin/Requests";
import Module from "./components/Module";

export default {
  mixins: [Translate, Requests],
  components: {Module},

  data(){
    return {
      modules: []
    }
  },

  created(){
    this.modules = window.MODUL.MODULES
  },

  computed: {
    userName(){
      if (window.MODUL.user.ID > 0) {
        return window.MODUL.user.data.display_name
      }
      return ''
    }
  },

  methods: {
    countUsersChanged(event, module) {
      //console.log(event)
      //console.log(module.courses.list)

      for(let i = 0; i < module.courses.list.length; i++){
        let course = module.courses.list[i]
        let key = course.id + ':' + course.date
        course.users = event[key] >= 0 ? event[key] : course.users
      }
    }
  }
}
</script>
